<template>
    <div class="about">
        <div class="aboutUS">
            <div id="head">
                <div class="text">
                    <span class="text1">您的诉求，是我们的追求</span><br>
                    <span class="text2">音书无障碍服务沟通平台</span>
                </div>
            </div>
            <div id="company">
                <span class="title">关于公司</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%;">
								<p>音书科技是国内领先的AI助残服务商，通过人工智能技术为听力言语障碍群体提供全场景无障碍沟通解决方案。</p>
								<p>在公共服务端，我们为教育、政务、医疗、公益、文化等300余家机构部署手语翻译机等无障碍设施及服务，构建包容性服务环境。</p>
								<p>在个人用户端，音书APP、小程序及智能手表等产品矩阵累计服务130万听障用户，形成从公共场景到个人生活的完整服务闭环。</p>
								<p>从机构到个体，音书科技持续以技术创新推动无障碍环境建设。</p>
                <span id="join" style="cursor: pointer;" @click="openUrl('https://www.zhipin.com/gongsir/4bf2213be61e308d1nd509u_EQ~~.html?ka=company-jobs')">加入我们</span>
            </div>
            <div style="width:90%;">
                <span class="title">发展历程</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%;">
                <div id="develop">
                    <!-- <img class="bgPic" src="../assets/about/develop@2x.png"> -->
                    <el-timeline>
                        <el-timeline-item v-for="(activity, index) in activities"
                        :key="index" type="success" color="white" size="large">
                            <div class="timeline">
                                <span>{{activity.timestamp}}</span>
                                <span style="text-align:left;">{{activity.content}}</span>
                                <img :src='activity.picSrc'>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
            <div style="width:55%">
                <span class="title">团队介绍</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%; margin-bottom:2%;">
                <div id="team" v-for="(mem, index) in members" :key="index">
                    <img :src="mem.pic" style="width:30%;">
                    <div style="width:60%">
                        <span class="text1">{{mem.name}}</span><br>
                        <span class="text2">{{mem.desc}}</span>
                    </div>
                </div>
            </div>
            <div style="width:55%; margin-top:5%;" id="contact-box">
                <span class="title">联系我们</span><br>
                <img src="../assets/about/underline_2x.png" style="width:40%;">
                <div id="contact" style="margin-top:2%;">
                    <div id="contact1">
                        <div @click="openCS" style="cursor: pointer;">
                            <img src="../assets/about/dianhua_2x.png">
                            <span>点击立刻在线沟通</span>
                        </div>
                        <div>
                            <img src="../assets/about/zhuanshufensi_2x.png">
                            <span>商务合作邮箱：bd@voibook.com</span>
                        </div>
                    </div>
                    <!-- <div id="contact2">
                        <div>
                            <img src="../assets/about/zhuanshufensi_2x.png">
                            <span>粉丝QQ群：663559320</span>
                        </div>
                        <div>
                            <img src="../assets/about/webicon306_2x.png">
                            <span>商务合作QQ：1956033634</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <myFooter></myFooter>
				<customer-service />
    </div>
</template>

<script>
import bus from '@/lib/bus.js'
import CustomerService from '@/components/CustomerService.vue'

export default {
	name: 'aboutPage',
  components: {
    CustomerService
  },
	data () {
		return {
			activities: [
				{
					content: '获评国家高新技术企业',
					timestamp: '2022.12',
					picSrc: require('../assets/about/gongsi_2x.png')
				},
				{
					content: '获得智能科技开放产业基金驰星创投战略投资',
					timestamp: '2021.2',
					picSrc: require('../assets/about/shouji_2x.png')
				},
				{
					content: '获得种子轮投资',
					timestamp: '2017.4',
					picSrc: require('../assets/about/shinshophezuo_2x.png')
				},
				{
					content: '广州音书科技有限公司注册成立',
					timestamp: '2016.7',
					picSrc: require('../assets/about/gongsi_2x.png')
				},
				{
					content: '团队入驻华南理工大学创业基地，项目正式落地',
					timestamp: '2016.4',
					picSrc: require('../assets/about/bangong_2x.png')
				}
			],
			members: [
				{
					pic: require('../assets/about/zfg.jpg'),
					name: '曾凡钢院士，首席顾问',
					desc: `美国工程院外籍院士，教育部长江学者评审员;
								加州大学尔湾分校听觉研究中心主任;
								美国国立卫生院（NIH)重点项目评审；
								创办和投资六家中美高科技公司`
				},
				{
					pic: require('../assets/about/scc.png'),
					name: '石城川，CEO',
					desc: `2023年世界互联网大会“全球青年领军者”；
									复旦大学MBA；
									曾荣获福布斯亚洲“30Under30”和卡地亚CWI“多元、平等和包容性奖”；
									熟悉听力行业和言语康复行业；
									立志实现听障人士实现无障碍沟通；
									负责公司战略规划`
				},
				{
					pic: require('../assets/about/cgq.png'),
					name: '陈国强，技术合伙人',
					desc: `2020福布斯亚洲30 Under 30；
								华南理工大学软件工程硕士；
								从事机器学习算法研究；
								2014全国数学模型比赛一等奖；
								2016全国移动终端设计大赛冠军；
								负责公司技术研发`
				},
				{
					pic: require('../assets/about/wfy.png'),
					name: '王飞扬，市场合伙人',
					desc: `曾任深圳某重点中学在编物理教师；
								浙江大学硕士；
								立志通过AI赋能教育行业；
								户外运动爱好者，多次横渡钱塘江；
								负责公司市场推广`
				},
				{
					pic: require('../assets/about/psq.png'),
					name: '彭驷庆，产品合伙人',
					desc: `毕业于华南理工大学工控系；
								二次创业者；
								多年外企市场营销经验；
								熟悉互联网产品及工业品营销模式；
								负责公司产品研发`
				}
			]
		}
	},
	methods: {
		openUrl (url) {
				window.open(url, '_blank')
		},
    openCS () {
			const btn = document.getElementById('custom-service-btn')
			// API 不可用，触发按钮点击事件，让企点 DOM 型绑定的事件接管
			var event = new MouseEvent('click', {
					bubbles: true,
					cancelable: true,
					view: window
			})
			btn.dispatchEvent(event)
    }
	},
	mounted () {
		bus.$emit('changeSelectedIndex', 3)
		if (this.$route.params.anchor !== 'none') {
			location.href = '#' + this.$route.params.anchor
		} else {
			if (document.documentElement) {
				document.documentElement.scrollTop = 0
			} else {
				document.body.scrollTop = 0
			}
		}
	}
}
</script>

<style scoped>
@import './about.css';
</style>



// WEBPACK FOOTER //
// src/pages/About.vue